module.exports = __webpack_public_path__ + "static/media/body.8bcda291.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/BodyView/body.svg
// module id = 950
// module chunks = 0